import { Form } from "antd";
import { SharedButton } from "./shared";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useHistory } from "react-router";
interface IProps {
  cancel?: () => void;
}
export const FormAction = ({ cancel }: IProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const goBack = () => history.goBack();
  return (
    <Form.Item>
      <StyledFormAction>
        <SharedButton
          type="default"
          htmlType="button"
          size="middle"
          onClick={cancel ? cancel : goBack}
        >
          {t("page.cancel")}
        </SharedButton>
        <SharedButton type="primary" htmlType="submit" size="middle">
          {t("page.create")}
        </SharedButton>
      </StyledFormAction>
    </Form.Item>
  );
};

const StyledFormAction = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 40px;
`;
